import { render } from "./CompensatoriosView.vue?vue&type=template&id=d15296fe"
import script from "./CompensatoriosView.vue?vue&type=script&lang=js"
export * from "./CompensatoriosView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__